import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";

import {
	EventContext,
	OfferOptionsContext,
	OfferColumnConfigurationResult,
} from "@gp/components";
import { EventDetails } from "..";
import { useIsAdditionalOfferVisible } from "@utils/offer";

import useGetIsEventFeatured from "@state/hooks/offer/useGetIsEventFeatured";

import { EventOfferWrapper, AdditionalOfferButton } from ".";

export const MainOffer = observer(function MainOffer(props: {
	secondaryColumns: OfferColumnConfigurationResult;
	mainColumns: OfferColumnConfigurationResult;
	additionalOfferCount: number;
	isAlternate?: boolean;
	displaySport?: boolean;
	offerCategory?: string;
}) {
	const event = useContext(EventContext);
	const isUpcoming = event.isUpcoming;
	const options = useContext(OfferOptionsContext);

	const isEventFeatured = useGetIsEventFeatured();

	const isAdditionalOfferVisible = useIsAdditionalOfferVisible();

	const primaryOfferDivClasses = classNames("offer__body__row", {
		"offer--sports__main__row offer__main__row":
			!props.secondaryColumns.isEmpty,
		"offer__main__row--sml": !props.secondaryColumns.isEmpty && isUpcoming,
		"is-collapsed": isAdditionalOfferVisible,
		"is-selected": isEventFeatured,
		odd: props.isAlternate,
		//@ts-expect-error
		"is-top-event": !options?.shouldHideTopTag && event.isTopEvent,
	});

	return (
		<div className={primaryOfferDivClasses}>
			<EventDetails
				offerCategory={props.offerCategory}
				hasSecondaryOffer={!props.secondaryColumns.isEmpty}
				displaySport={props.displaySport}
				isEventFeatured={isEventFeatured}
				isAdditionalOfferVisible={isAdditionalOfferVisible}
			/>
			<EventOfferWrapper mainColumns={props.mainColumns} />

			<AdditionalOfferButton
				additionalOfferCount={props.additionalOfferCount}
				isSecondaryColumnsEmpty={props.secondaryColumns.isEmpty}
				isEventFeatured={isEventFeatured}
				displaySport={props.displaySport}
				isAdditionalOfferVisible={isAdditionalOfferVisible}
			/>
		</div>
	);
});
